"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var arrowWinner_1 = tslib_1.__importDefault(require("./components/arrowWinner"));
var content_1 = tslib_1.__importDefault(require("./components/content"));
var facebookSymbol_1 = tslib_1.__importDefault(require("./components/facebookSymbol"));
var instagramSymbol_1 = tslib_1.__importDefault(require("./components/instagramSymbol"));
var quoteDown_1 = tslib_1.__importDefault(require("./components/quoteDown"));
var quoteUp_1 = tslib_1.__importDefault(require("./components/quoteUp"));
var treeNodeClose_1 = tslib_1.__importDefault(require("./components/treeNodeClose"));
var treeNodeOpen_1 = tslib_1.__importDefault(require("./components/treeNodeOpen"));
var twitterSymbol_1 = tslib_1.__importDefault(require("./components/twitterSymbol"));
var youtubeSymbol_1 = tslib_1.__importDefault(require("./components/youtubeSymbol"));
exports["default"] = {
    'quote-up': quoteUp_1["default"],
    'quote-down': quoteDown_1["default"],
    'facebook-symbol': facebookSymbol_1["default"],
    'twitter-symbol': twitterSymbol_1["default"],
    'instagram-symbol': instagramSymbol_1["default"],
    'youtube-symbol': youtubeSymbol_1["default"],
    arrowWinner: arrowWinner_1["default"],
    'tree-node-open': treeNodeOpen_1["default"],
    'tree-node-close': treeNodeClose_1["default"],
    content: content_1["default"]
};
